import CACA1110RequestModel from '@/api/data/CAC/CACA1110/CACA1110RequestModel'
import CACA1110ResponseModel from '@/api/data/CAC/CACA1110/CACA1110ResponseModel'

import RestService from '@/common/RestService'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CACG1110Service {
  /**
   *
   * @param productNo
   * @param shhnCd
   * @returns CACA1110ResponseModel
   */
  public async callAPICACA1110(
    productNo,
    shhnCd
  ): Promise<CACA1110ResponseModel> {
    const caca1110RequestModel = new CACA1110RequestModel()
    caca1110RequestModel.productNo = productNo
    caca1110RequestModel.shhnCd = shhnCd
    const caca1110ResponseModel: CACA1110ResponseModel = <
      CACA1110ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1110, caca1110RequestModel)
    return caca1110ResponseModel
  }
}
